<template>
  <div v-if="!($mq.resize && $mq.below('768px'))" class="cart-pop" :class="{ 'pop': popshow || localshow }" @mouseover="onPophover" @mouseleave="onPopleave">
    <div class="cart-list">
      <div v-if="cartlist" class="cart-item" v-for="(item, index) in cartlist" :key="index">
        <img :src="item.beer.beer_image ? item.beer.beer_image.path : '/static/beer-placeholder.jpg'" />
        <div class="cart-desc">
          <span class="cart-title">{{ item.beer.description }}</span>
          <span class="cart-text">{{ item.beer.description2 }}</span>
          <span class="cart-text">{{ $t('currency.malaysia') }} {{ item.beer.user_price }}</span>
          <span class="cart-text">Quantity: {{ item.quantity }}</span>
          <span class="cart-subtotal">{{ $t('currency.malaysia') }} {{ roundUp(item.beer.user_price * item.quantity) }}</span>
        </div>
      </div>
    </div>
    <div class="cart-footer">
      <div class="cart-total">
        <span class="title">Total: {{ $t('currency.malaysia') }} {{ totalamount }}</span>
      </div>
      <div class="cart-action">
        <el-button class="orange-button cart-button" @click="onViewCartClick($t('route.cart'))">
          {{ $t('button.viewcart') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'cart-pop',
  props: {
    popshow: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      cartlist: 'cartbeers'
    })
  },
  watch: {
    cartlist: {
      immediate: true,
      deep: true,
      handler: 'fetchCartList'
    }
  },
  data () {
    return {
      totalamount: 0,
      timer: undefined,
      localshow: false,
      loaded: false
    }
  },
  mounted () {
    this.getTotalAmount(this.cartlist)
  },
  methods: {
    fetchCartList (newval, oldval) {
      // console.log(newval, oldval)
      let exec = false
      if (newval && !oldval) {
        exec = true
      } else if (newval.length >= oldval.length && newval.length > 0) {
        exec = true
      }
      let value = this.$ls.get('init')
      // console.log('value', value)
      if (value) {
        exec = false
        this.$ls.remove('init')
      }
      if (exec) {
        this.getTotalAmount(newval)
        this.localshow = true
        this.timer = setTimeout(() => {
          this.localshow = false
          this.timer = undefined
        }, 2000)
        // if (this.$mq.resize && this.$mq.below('768px')) {
        //   console.log('call message')
        // }
        this.$message({
          duration: 1000,
          message: 'Successfully added to cart.',
          iconClass: 'el-icon-check',
          customClass: 'custom-alert'
        })
      }
    },
    getTotalAmount (list) {
      if (!list) {
        return 0
      }
      let total = 0
      list.forEach((item) => {
        total += (item.quantity * item.beer.user_price)
      })
      this.totalamount = this.roundUp(total)
    },
    onViewCartClick (name) {
      this.$router.push({ name })
    },
    onPophover () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = undefined
      }
      this.localshow = true
    },
    onPopleave () {
      this.timer = setTimeout(() => {
        this.localshow = false
        this.timer = undefined
      }, 500)
    },
    roundUp (value) {
      return (Math.round(value * 100) / 100).toFixed(2)
    }
  }
}
</script>
<style lang="scss">
.icon-button .el-button--medium {
  padding: 0;
}
</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.cart-pop {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  background: #fff;
  width: 290px;
  max-height: 410px;
  z-index: 999;
  padding: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  opacity: 0;
  visibility: hidden;
  transition: all 300ms ease-out;
  &.pop {
    visibility: visible;
    opacity: 1;
    transition: all 300ms ease-out;
  }
  & > .cart-list {
    max-height: 310px;
    overflow-y: auto;
    .cart-item {
      padding-bottom: 15px;
      display: flex;
      flex-direction: row;
      width: 100%;
      & > img {
        width: 120px;
        height: 120px;
        border: 1px solid #ccc;
        border-radius: 5px;
      }
      .cart-desc {
        padding-left: 15px;
        overflow: hidden;
        & >  span {
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          padding-bottom: 3px;
        }
        .cart-subtotal {
          padding-top: 10px;
          font-weight: bold;
          font-family: 'AlteHaasGroteskBold';
        }
      }
    }
  }
  & > .cart-footer {
    height: 100px;
    .cart-total {
      padding: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CartPop.vue